import commonMapping from "@/mapping/common";

export const logs = {
  allow_sites_enable: commonMapping.intToBoolean,
  block_sites_service_enable: commonMapping.intToBoolean,
  conn_web_interface_enable: commonMapping.intToBoolean,
  router_operation_enable: commonMapping.intToBoolean,
  dos_attacks_port_scan_enable: commonMapping.intToBoolean,
  port_forwarding_triggering_enable: commonMapping.intToBoolean,
  wireless_access_enable: commonMapping.intToBoolean,
  wireless_signal_sched_enable: commonMapping.intToBoolean,
  vpn_services_enable: commonMapping.intToBoolean,
};

export default logs;
